var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main_box"},[_c('MenuComponent'),_c('FirstScreenComponent'),_c('GalleryComponent'),_c('ServicesComponent'),_c('BookingComponent'),_c('HousingOptionsComponent'),_c('AmoFormComponent'),_c('SimpleGalleryComponent'),_c('FeedbackComponent'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }